import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as StandaloneLogo } from '../../../../assets/images/common/icons/standalone-logo.svg'
import { getLevel } from '../../../../utility/curriculumHelper'
import { getMomentInCommunityTimezoneReversed, DATETIME_FORMAT } from '../../../../utility/datesHelper'
import moment from 'moment'
import DIVISIONS from '../../../../constants/divisions.json'

import classes from './LeaderboardReport.module.scss'

const LeaderboardReport = () => {
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const event = useSelector(state => state.nineHoleEvent)
  const startTime = getMomentInCommunityTimezoneReversed(moment(event.eventDate), timezone, DATETIME_FORMAT)
  const [leaderboardPages, setLeaderboardPages] = useState([])

  const getMilestone = (activity) => {
    if (activity.milestone === 'event-winner') {
      return 'Medalist'
    } else if (activity.milestone === 'record-score') {
      return 'New Record'
    } else if (activity.score < 37) {
      return 'Passed'
    }
  }

  useEffect(() => {
    if (event.status !== 'completed') { return }

    let page = 0
    const leaderboardPages = [DIVISIONS.map(d => ({ ...d, activities: [] }))]
    const activities = [...event.students].filter(s => s.status !== 'declined').sort((a, b) => {
      const diff = a.yardage - b.yardage
      if (diff !== 0) { return diff }

      return a.score - b.score
    })

    activities.forEach((activity, index) => {
      const division = leaderboardPages[page][getLevel(activity.fullTeeYardage || activity.yardage) - 1]
      division.activities.push(activity)

      if (index % 13 === 12) {
        leaderboardPages[page].forEach((division) => {
          division.activities.sort((a, b) => a.score - b.score)
        })
        page += 1
        leaderboardPages.push(DIVISIONS.map(d => ({ ...d, activities: [] })))
      }
    })

    setLeaderboardPages(leaderboardPages)
  }, [event])

  return (
    <div id='leaderboard' className={classes.leaderboardReport}>
      {leaderboardPages.map((leaderboard, index) => (
        <div className='LeaderboardPage p-5' key={index}>
          <div className='d-flex justify-content-between w-100'>
            <div className={classes.title}>
              Leaderboard - {event.name}
            </div>
            <StandaloneLogo/>
          </div>

          <div className={classes.date}>
            {startTime.format('MMM D, YYYY h:mma')} - {startTime.clone().add(1, 'hours').format('h:mma')}
          </div>
          {
            leaderboard.filter(division => division.activities && division.activities.length > 0).map((division, index) => (
              <div key={index}>
                <div className={classes.header}>
                  <div className={classes.level}>Level{division.order}</div>
                  <div className={classes.player}>Player</div>
                  <div className={classes.score} style={{ textAlign: 'center' }}>Score</div>
                  <div className={classes.milestone}>Milestone</div>
                </div>
                {division.activities.map((activity) => (
                  <tr
                    key={activity.id}
                    className={classes.studentRow}
                  >

                    <td className={classes.level}>
                      <MiniDivisionBadge />
                      <div className={classes.levelValue}>{division.order}</div>
                    </td>
                    <td className={classes.player}>
                      {activity.firstName} {activity.lastName}
                    </td>
                    <td className={classes.score}>
                      {activity.score}
                    </td>
                    <td className={classes.milestone}>
                      {getMilestone(activity)}
                    </td>
                  </tr>
                ))}
              </div>
            ))
          }
        </div>
      ))}
    </div>
  )
}

export default LeaderboardReport
